export const ASSET_UPLOAD_DIALOG_DEFAULT_VALUES = {
  uploadType: 'asset',
  attachments: [],
  clear_existing: false,
  on_conflict_update: true
};

export default ASSET_UPLOAD_DIALOG_DEFAULT_VALUES;
